import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import {
  bookingMeetingTypes,
  type MeetingType,
} from "../schemas/bookingMeetingTypes";

export const getBookingMeetingTypesProps = z
  .object({
    bookingMarket: z.string(),
  })
  .extend(requestConfig.shape);

export type GetBookingMeetingTypesProps = z.infer<
  typeof getBookingMeetingTypesProps
>;

export const getBookingMeetingTypes = async (
  args: GetBookingMeetingTypesProps,
): Promise<MeetingType[]> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    proxyAuthSecret,
    bookingMarket,
  } = parseServiceInput(getBookingMeetingTypesProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    // no token necessary for Booking endpoints
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const params = new URLSearchParams({
    bookingMarket,
  });

  const response = await fetch(
    `${endpoint}/v1/bookings/meeting-types?${params.toString()}`,
    {
      method: "GET",
      headers,
    },
  );

  const data = await parseServiceOutput(response, bookingMeetingTypes, {
    code: "MALFORMED_MEETING_TYPES",
    message: "Issue getting Meeting Types",
  });
  return data.meetingTypes;
};
